import React from 'react';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';

import { useConfig } from '../../../defaultConfig';
import useTranslation from '../../../hooks/useTranslation';

const NotificationMessage = () => {
    const { featureToggles } = useConfig();
    const translated = useTranslation();
    if (featureToggles.enablePushRules) {
        return (
            <div className="notifications-settings__info-message">
                <InfoMessage icon={IconTypes.UTROPSTEGN_24} text={translated.pushNotifications.infoMessage} />
            </div>
        );
    }
    return (
        <div className="notifications-settings__info-message">
            <InfoMessage icon={IconTypes.UTROPSTEGN_24} text={translated.pushNotifications.soonMessage} />
        </div>
    );
};
export default NotificationMessage;
